import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { SN_DRAWER_DATA } from '@lib/ui/drawer';
@Component({
  selector: 'fs-sentry-search-results-drawer',
  templateUrl: './sentry-search-results-drawer.component.html',
  styleUrls: ['./sentry-search-results-drawer.component.scss'],
  providers: [ToastrService],
})
export class SentrySearchResultsDrawerComponent implements OnInit {
  constructor(@Inject(SN_DRAWER_DATA) public data: any) {}

  public ngOnInit(): void {}
}
